









































import { Vue, Prop } from 'vue-property-decorator'
import Component from 'vue-class-component'
import Tax from '@/dto/taxes/Tax'
import taxesStore from '@/stores/TaxStore'
import TaxesTableHeader from '@/components/taxes/TaxesTableHeader.vue'
import TaxesTableRow from '@/components/taxes/TaxesTableRow.vue'
import Country from '@/dto/deliveries/Country'
import LocationService from '@/services/LocationService'

@Component({
  components: { TaxesTableRow, TaxesTableHeader },
})
export default class TaxesTable extends Vue {
  @Prop(Array)
  public taxes!: Tax[]

  taxesStore = taxesStore
  countries: Country[] = []

  pagination = {
    rowsPerPage: 1000,
  }

  columns = [
    {
      name: 'fromCountryId',
      align: 'left',
      label: 'Из страны',
      field: 'fromCountryId',
      sortable: true,
    },
    {
      name: 'toCountryId',
      align: 'left',
      label: 'В страну',
      field: 'toCountryId',
      sortable: true,
    },
    {
      name: 'currency',
      align: 'left',
      label: 'Валюта',
      field: 'currencyCode',
      sortable: true,
    },
    {
      name: 'actions',
      align: 'left',
      label: '',
      field: 'actions',
    },
  ]

  created() {
    LocationService.getCountries().then(
      countries => (this.countries = countries)
    )
  }

  get selectedTax(): Tax | null {
    return this.taxesStore.tax
  }

  get selectedRow() {
    return this.selectedTax ? [this.selectedTax] : []
  }
}
